import { Directive, OnInit, AfterViewInit, Output, EventEmitter, Input, ElementRef, Injector, ApplicationRef, EmbeddedViewRef, Renderer2, ComponentFactoryResolver, ChangeDetectorRef, ComponentFactory, ComponentRef } from '@angular/core';
import { config } from './select.config';
import { SelectComponent } from './select.component';
import { Options, SelectConfig } from '../models/';
//import { ViewRef } from '@angular/core/src/render3/view_ref';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[Select]'
})
export class SelectDirective implements OnInit, AfterViewInit {

  @Output() outData: EventEmitter<Options | string> = new EventEmitter<Options | string>();

  @Input('config') config: SelectConfig;
  /**
   * option permettant d'activer ou non le filtre
  */
  @Input('isFilter') isFilter: boolean;
  /**
   * option permettant de savoir si l'on retourne dans l'output la value de l'option ou l'option entierement
  */
  @Input('isValue') isValue: boolean;
  /**
   * option permettant de paramétrer le placeholder dans le cas ou l'option de recherche serait activé
  */
  @Input('placeHolder') placeHolder: string;
  /**
   * propriété qui indique la taille et le positionnement de la liste
   */
  @Input('placement') placement: string;
  /**
   * permet de connaitre la height de l'élément
   */
  @Input('height') height: number;
  /**
   * permet de savoir si on doit mettre la premiere value à true ou à false
   */
  @Input('ChangeFirstValue') ChangeFirstValue: boolean;
  /**
   * permet d'affecter une class au composant'
   */
  @Input('class') class: string;
  /**
   * permet d'empecher la selection du select'
   */
  @Input('disabled') disabled: boolean;
  /**
   * permet de dire si la selection d'une option est obligatoire'
   */
  @Input('required') required: string;
  /**
   * Liste des options
  */
  public list: Array<Options>;
  /**
   * recupere les changements sur le dom
  */
  private changes: MutationObserver;

  constructor(
    private element: ElementRef,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
    private render: Renderer2,
    private cd: ChangeDetectorRef,

  ) { }

  // #region cycle de vie
  /**
   * @ignore
   */
  ngOnInit(): void {
    // Initialisation de la list des options
    this.list = new Array<Options>();

    // Initialisation de la valeur de retour
    if (this.isValue === null || this.isValue === undefined) {
      this.isValue = true;
    }

    // Initialisation du require
    if (this.required === null || this.required === undefined) {
      this.required = '';
    }

    // Initialisation du disabled
    if (this.disabled === null || this.disabled === undefined) {
      this.disabled = false;
    }
    if (this.disabled) {
      this.isFilter = false;
    }

    // Initialisation du placement de la liste par rapport à l'élément
    if (this.placement === null || this.placement === undefined) {
      this.placement = 'left';
    }

    // Initialisation du placeHolder
    this.placeHolder = this.placeHolder === null || this.placeHolder === undefined ? 'Recherche' : this.placeHolder;

    // Initialisation de la configuration
    if (this.config === undefined || this.config === null) {
      this.config = config;
    } else {
      const customProps: Array<string> = Object.getOwnPropertyNames(this.config);
      // for (const customProp of customProps) {
      //   if (customProps[customProp] === null || customProps[customProp] === undefined) {
      //     this.config[customProp] = config[customProp];
      //   }
      // }
      for (let i: number = 0; i < customProps.length; i++) {
        if (customProps[i] === null || customProps[i] === undefined) {
          switch (customProps[i]) {
            case 'buttonClass':
            this.config.buttonClass = config.buttonClass;
            break;
            case 'inputClass':
            this.config.inputClass = config.inputClass;
            break;
            case 'listClass':
            this.config.listClass = config.listClass;
            break;
          }
        }
      }
    }
  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {

    setTimeout(() => {
      // transformation du DOM en objet
      // On recupere les options du select et on les pousse dans un tableau de class Array<Option>
      let filter: string = '';
      const select: any = this.element.nativeElement;
      if (select.children.length > 0) {
        const option: Options = new Options;
        option.value = select.children[0].value;
        option.text = select.children[0].textContent;
        option.selected = select.children[0].selected;
        this.list.push(option);
        let trueInSelect: boolean = false;
        for (let i: number = 1; i < select.children.length; i++) {
          const opt: Options = new Options;
          opt.value = select.children[i].value;
          opt.text = select.children[i].textContent;
          opt.selected = select.children[i].selected;
          if (opt.selected) {
            trueInSelect = true;
            if (this.isFilter) {
              filter = opt.text;
            }
          }
          this.list.push(opt);
        }
        if (trueInSelect) {
          this.list[0].selected = false;
        } else {
          this.list[0].selected = true;
          if (this.ChangeFirstValue) {
            this.list[0].selected = false;
            filter = '';
          } else {
            filter = this.list[0].text;
          }
        }
      }
      // On crée le composant dynamiquement
      const factory: ComponentFactory<SelectComponent> = this.cfr.resolveComponentFactory(SelectComponent);
      const componentRef: ComponentRef<SelectComponent> = factory.create(this.injector);

      // On passe au composant les inputs dont il a besoin (instance liste les propriétés du composant)
      componentRef.instance.style = this.config;
      componentRef.instance.options = this.list;
      componentRef.instance.isFilter = this.isFilter;
      componentRef.instance.isValue = this.isValue;
      componentRef.instance.placeHolder = this.placeHolder;
      componentRef.instance.filter = filter;
      componentRef.instance.placement = this.placement;
      componentRef.instance.class = this.class;
      componentRef.instance.disabled = this.disabled;
      componentRef.instance.required = this.required;

      // Initialisation du placement de la liste par rapport à l'élément
      if (this.height === null || this.height === undefined) {
        this.height = select.clientHeight;
      }
      componentRef.instance.sizeElement = { width: select.clientWidth, height: this.height };

      // On recupere l'output du composant
      componentRef.instance.outData.subscribe(
        (res: Options | string) => {
          this.outData.emit(res);
        }
      );

      // // On affecte les classes à l'élément
      // const classs = this.class.split(' ');
      // if (classs.length > 0) {
      //   for (const c of classs) {
      //     this.render.addClass(this.element.nativeElement, c);
      //   }
      // }

      // On définit le composant comme un noeud du DOM
      const view: any = componentRef.hostView;
      this.appRef.attachView(view);
      const domElement: HTMLElement = (view as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      this.cd.detectChanges();

      // On insere le composant dans le DOM à la place du select et on supprime le select
      this.render.insertBefore(select.parentElement, domElement, select);
      this.render.removeChild(select.parentElement, select);
      this.cd.detectChanges();

      // Observer sur les changements du dom pour régénérer la list à l'interieur du composant
      this.changes = new MutationObserver((mutations: Array<MutationRecord>): void => {
        const list: Array<Options> = new Array<Options>();
        let increment: number = 0;
        for (let j: number = 0; j < mutations.length; j++) {
          const mut: NodeListOf<any> = mutations[j].target.childNodes;
          if (mutations[j].removedNodes.length === 0) {
            let cpt: number = 0;
            for (let i: number = 0; i < mut.length; i++) {
              if (mut[i]['nodeName'] === 'OPTION') {
                const option: Options = new Options;
                option.value = mut[i]['value'];
                option.text = mut[i].textContent;
                if (cpt === 0) {
                  if (this.ChangeFirstValue) {
                    option.selected = false;
                  } else {
                    option.selected = true;
                  }
                } else {
                  option.selected = mut[i]['selected'];
                }
                list.push(option);
                cpt++;
              }
            }
            componentRef.instance.options = list;
            let filters: string = '';
            if (this.isFilter) {
              for (const element of list) {
                if (element.selected) {
                  filters = element.text;
                  break;
                }
              }
            }
            componentRef.instance.filter = filters;
            increment++;
          }
          if (increment === 1) {
            break;
          }
        }
      }
      );

      this.changes.observe(this.element.nativeElement, {
        attributes: true,
        childList: true,
        characterData: true,
      });
    }, 100);
  }
  // #endregion
}
